<template>
  <div class="main_div">
    <div class="main_income">
      <div class="row income_block" v-for="(income) in incomes">
        <div class="col-md-2">
          <input type="number" v-model="income.sum" class="form-control">
        </div>
        <div class="col-md-2">
          <select v-model="income.currency_id" class="form-control">
            <option v-for="(currency, index) in currencies" :value="index">{{currency}}</option>
          </select>
        </div>
        <div class="col-md-5">
          <input type="text" placeholder="Комментарий" v-model="income.comment" class="form-control">
        </div>
        <div class="col-md-3">
          <select v-model="income.to_user_id" class="form-control">
            <option v-for="(user, index) in toUsers" :value="index">{{user}}</option>
          </select>
        </div>
      </div>
      <div class="flex flex-jc-between">
        <button @click="addNew()" class="btn btn-sm btn-info">Новая инкассация</button>
        <vue-ladda v-if="incomes.length" @click="save()" button-class="btn btn-sm btn-success"
                   data-style="zoom-in"
                   :loading="btnLoading">Сохранить инкассации
        </vue-ladda>
      </div>
    </div>
  </div>
</template>

<script>

  import api from '@/api'
  import VueLadda from 'vue-ladda/src/vue-ladda.vue'

  export default {
    components: {
      VueLadda
    },
    props: ['currencies', 'reportDate', 'toUsers', 'userId', 'updateIncomes', 'date'],
    data() {
      return {
        btnLoading: false,
        incomes: [],
      }
    },
    methods: {
      addNew() {
        this.incomes.push({
          sum: 0,
          to_user_id: Object.keys(this.toUsers)[0],
          // currency_id: Object.keys(this.currencies)[0],
          currency_id: 33,
          comment: null,
          saved: false,
        });
      },
      async save() {
        this.btnLoading = true;
        let validation = true;
        this.incomes.forEach((inc) => {
          if (!inc.sum || inc.sum < 0) validation = false;
        })

        if (!validation) {
          toastr['warning']('Не все поля заполнены верно' || 'Ошибка');
          this.btnLoading = false;
          return;
        }

        const {data} = await api.post('/reports/updateIncomes', {
          incomes: this.incomes,
          date: this.date,
          user_id: this.userId
        });
        if (data.success) {
          toastr['success']('Сохранено');
          // this.incomes.forEach(inc => inc.saved = true)
          this.incomes = [];
          this.updateIncomes(data.incomes);
        } else {
          toastr['warning'](data.message || 'Ошибка');
        }
        this.btnLoading = false;
      }
    }
  }

</script>

<style scoped>
  .income_block {
    padding: 15px;
    padding-bottom: 10px;
  }

  .income_block div {
    padding: 0;
  }

  .income_block select,
  .income_block input {
    border-radius: 0;
  }

</style>
